import e from "../managers/braze-instance.js";
import re from "./feed-provider-factory.js";
export function subscribeToFeedUpdates(r) {
  if (e.X()) return re.rr().Zs(r);
}
